const Index = () =>
  import(/* webpackChunkName: "inbound-delivery-person" */ "./index.vue");
const List = () =>
  import(
    /* webpackChunkName: "inbound-delivery-person" */ "./components/List.vue"
  );

export default [
  {
    path: "inboundDeliveryPerson",
    name: "inbound-delivery-person",
    component: Index,
    redirect: { name: "inbound-delivery-person-list" },
    children: [
      {
        path: "list",
        name: "inbound-delivery-person-list",
        component: List,
        meta: {
          title: "Inbound Delivery People",
        },
      },
    ],
  },
];
